import angular from 'angular';
import uiRouter from 'angular-ui-router';
import racedayEditPageComponent from './racedayEditPage.component';

let racedayEditPageModule = angular.module('racedayEditPage', [
  uiRouter
])

.component('racedayEditPage', racedayEditPageComponent)

.name;

export default racedayEditPageModule;
